import React, { memo } from 'react';
import { Link } from 'react-router-dom';

import { Row } from 'xpi-black-ui/Base/Grid';

import BlackContainer from 'components/Common/BlackContainer';

import { Container } from './styles';

const MainMenu = memo(({ menu, menuSelected }) => {
  return (
    <Container>
      <BlackContainer>
        <Row>
          {menu?.map(link => (
            <Link
              key={link.id}
              to={link.referenciaMenu}
              className={menuSelected === link.referenciaMenu ? 'selected' : ''}
            >
              {link.descricaoMenu}
            </Link>
          ))}
        </Row>
      </BlackContainer>
    </Container>
  );
});

export default MainMenu;
